"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserGestor = exports.UsersRol = exports.PageUsers = exports.Administrador = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var reactstrap_2 = require("reactstrap");
var reactstrap_3 = require("reactstrap");
var classnames_1 = require("classnames");
var url_js_1 = require("../variables/url.js");
var react_select_1 = require("react-select");
var espolAds_js_1 = require("../variables/espolAds.js");
/*const localBack = 'http://localhost:3368/';*/
var localBack = url_js_1.default.localBack;
var account = localBack + 'api/accounts/';
var correoMasivo = localBack + 'api/catalog/correomasivo/emailApersona/';
var areas = localBack + 'api/Catalog/Area';
var styles = {
    container: {
        width: 400,
        padding: "30px 90px",
        margin: "50px auto",
        backgroundColor: "#f4ff81",
        borderRadius: "10px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    password: {
        width: 300,
        padding: "8px 10px",
        border: "1px solid #444",
        borderRadius: "10px",
        outline: "none",
    },
    statusBar: {
        width: 300,
        height: 10,
        marginTop: 20,
        background: "#fff",
        border: "1px solid #444",
        borderRadius: "5px",
    },
    strength: {
        height: "100%",
        maxWidth: "100%",
        backgroundColor: "orange",
    },
    message: {
        padding: "20px 0",
    },
    button: {
        padding: "15px 30px",
        cursor: "pointer",
        background: "purple",
        color: "#fff",
        fontWeight: "bold",
        border: "none",
        borderRadius: "30px",
    },
    disabledButton: {
        cursor: "not-allowed",
        opacity: 0.3,
    },
};
var Administrador = /** @class */ (function (_super) {
    __extends(Administrador, _super);
    function Administrador(props) {
        var _this = _super.call(this, props) || this;
        _this.cambiarPagina = function (page) {
            if (page != null)
                fetch(page, {
                    method: 'GET',
                    headers: { "Authorization": "Bearer " + espolAds_js_1.getCookie('token') },
                })
                    .then(function (response) { return response.json(); })
                    .then(function (dataB) {
                    _this.setState({ pageUsers: dataB });
                });
        };
        _this.handleKeyPress = function (event) {
            if (event.charCode === 13 && _this.state.buscar !== "") {
                //console.log('enter press here! ');
                /*console.log("Buscar", this.state.buscar);  */
                _this.cambiarTap(_this.state.buscar);
            }
        };
        _this.cambiarTap = function (name) {
            if (name == null)
                fetch(account + 'Users/page/', {
                    method: 'GET',
                    headers: { "Authorization": "Bearer " + espolAds_js_1.getCookie('token') },
                })
                    .then(function (response) {
                    _this.setState({ status: response.status });
                    return response.json();
                })
                    .then(function (dataP) {
                    _this.setState({ pageUsers: dataP, loading: false, buscar: "" });
                });
            if (name != null)
                fetch(account + "Users/page/" + name, {
                    method: 'GET',
                    headers: { "Authorization": "Bearer " + espolAds_js_1.getCookie('token') },
                })
                    .then(function (response) {
                    _this.setState({ status: response.status });
                    return response.json();
                })
                    .then(function (dataP) {
                    _this.setState({ pageUsers: dataP });
                });
            /*console.log(this.state.pageUsers);*/
        };
        _this.onChangeMulti = function (selectedChange) {
            if (selectedChange.length !== 0) {
                _this.setState({ OtrasAreas: selectedChange.map(function (x) { return x.value; }) }, function () {
                    return console.log('Seleccionado Multiple: ', _this.state.OtrasAreas);
                });
            }
            else {
                /*console.log('no existe', selectedChange)*/
                _this.setState({ OtrasAreas: [] });
            }
        };
        _this.state = {
            users: [],
            cookie: espolAds_js_1.getCookie("username"),
            usersRole: [],
            creadorRole: [],
            revisorRole: [],
            adminRole: [],
            areas: [],
            OtrasAreas: [],
            loading: true,
            notpass: true,
            notvalid: true,
            activeTab: '1',
            idArea: 81,
            buscar: "",
            role: "",
            palabrasinmortales: "",
            usuario: "",
            UserName: "",
            nombreBusqueda: "",
            apellidoBusqueda: "",
            respuestaUser: { userId: "", userName: "", gestorId: 0, areaPrincipalId: 0, nombreCompleto: "", areasExtra: [], mensaje: "", code: true },
            status: 0,
            nuevoRol: 0,
            nuevoGestor: 0,
            pageUsers: {
                pageNumber: 0, pageSize: 0, firstPage: "", lastPage: "", totalPages: 0,
                totalRecords: 0, nextPage: "", previousPage: "", data: [], succeeded: false, errors: "", message: ""
            }
        };
        fetch(account + 'users/page', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${sessionStorage.getItem('token')}` },*/
            headers: { "Authorization": "Bearer " + espolAds_js_1.getCookie('token') },
        })
            .then(function (response) {
            _this.setState({ status: response.status });
            return response.json();
        })
            .then(function (dataP) {
            _this.setState({ pageUsers: dataP, loading: false });
        });
        fetch(account + 'Claims-Roles/Creador', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${sessionStorage.getItem('token')}` },*/
            headers: { "Authorization": "Bearer " + espolAds_js_1.getCookie('token') },
        })
            .then(function (response) {
            //this.setState({ status: response.status });
            return response.json();
        })
            .then(function (dataC) {
            /*console.log("creadores", dataC)*/
            _this.setState({ creadorRole: dataC });
        });
        fetch(account + 'Claims-Roles/Revisor', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${sessionStorage.getItem('token')}` },*/
            headers: { "Authorization": "Bearer " + espolAds_js_1.getCookie('token') },
        })
            .then(function (response) {
            //this.setState({ status: response.status });
            return response.json();
        })
            .then(function (dataR) {
            /*console.log("revisor", dataR)*/
            _this.setState({ revisorRole: dataR });
        });
        fetch(account + 'Claims-Roles/Administrador', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${sessionStorage.getItem('token')}` },*/
            headers: { "Authorization": "Bearer " + espolAds_js_1.getCookie('token') },
        })
            .then(function (response) {
            //this.setState({ status: response.status });
            return response.json();
        })
            .then(function (data) {
            /*console.log("admin", data)*/
            _this.setState({ adminRole: data });
        });
        fetch(areas)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ areas: data });
        });
        // This binding is necessary to make "this" work in the callback        
        _this.handleSearch = _this.handleSearch.bind(_this);
        _this.handleInmortales = _this.handleInmortales.bind(_this);
        _this.handleUsuarioName = _this.handleUsuarioName.bind(_this);
        _this.handleUserName = _this.handleUserName.bind(_this);
        _this.handleNombreBusq = _this.handleNombreBusq.bind(_this);
        _this.handleApellidoBusq = _this.handleApellidoBusq.bind(_this);
        _this.comboRole = _this.comboRole.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.onChangeArea = _this.onChangeArea.bind(_this);
        _this.onChangeMulti = _this.onChangeMulti.bind(_this);
        return _this;
    }
    Administrador.prototype.handleInputChange = function (event) {
        var target = event.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        var name = target.name;
        /*console.log(name, value) */
    };
    Administrador.prototype.listaMultiSelect = function (areas) {
        var opciones = areas.map(function (ej) {
            return ({ value: ej.idArea, label: ej.txNombreArea });
        });
        /*console.log(opciones);*/
        return opciones;
    };
    Administrador.prototype.removeRole = function (id, tipo) {
        var _this = this;
        var data = JSON.stringify({
            "roleName": tipo,
            "userId": id
        });
        /*console.log("Remover",data);*/
        fetch(account + 'removeRole', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + espolAds_js_1.getCookie('token') },
            body: data,
        }).then(function (response) {
            /*console.log(response.status)*/
            _this.setState({ nuevoRol: response.status });
            _this.props.history.push("/admin/user-admin");
        }).catch(function (err) {
            alert('A ocurrido un problema');
        });
    };
    Administrador.prototype.assignRole = function (id, tipo) {
        var _this = this;
        var data = JSON.stringify({
            "roleName": tipo,
            "userId": id
        });
        /*console.log("Asignar",data);*/
        fetch(account + 'assignRole', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + espolAds_js_1.getCookie('token') },
            body: data,
        }).then(function (response) {
            /*console.log(response.status)*/
            _this.setState({ nuevoRol: response.status });
            _this.props.history.push("/admin/user-admin");
        }).catch(function (err) {
            alert('A ocurrido un problema');
        });
    };
    Administrador.prototype.crearGestor = function (userName, idArea) {
        var _this = this;
        var data = JSON.stringify({
            "userName": userName,
            "idArea": idArea
        });
        fetch(account + 'Gestor', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + espolAds_js_1.getCookie('token') },
            body: data,
        }).then(function (response) {
            /*console.log(response.status)*/
            _this.setState({ nuevoGestor: response.status, notvalid: true, activeTab: "1" });
        }).catch(function (err) {
            alert('A ocurrido un problema');
        });
    };
    Administrador.prototype.checkChange = function (id, tipo, check) {
        if (tipo == "Administrador") {
            var admins = this.state.adminRole;
            if (check) {
                var el = admins.indexOf(id);
                if (el > -1) {
                    admins.splice(el, 1);
                    this.setState({ adminRole: admins });
                    this.removeRole(id, "Administrador");
                }
            }
            else {
                admins.push(id);
                this.setState({ adminRole: admins });
                this.assignRole(id, "Administrador");
            }
        }
        if (tipo == "Revisor") {
            var rev = this.state.revisorRole;
            if (check) {
                var el = rev.indexOf(id);
                if (el > -1) {
                    rev.splice(el, 1);
                    this.setState({ revisorRole: rev });
                    this.removeRole(id, "Revisor");
                }
            }
            else {
                rev.push(id);
                this.setState({ revisorRole: rev });
                this.assignRole(id, "Revisor");
            }
        }
        if (tipo == "Creador") {
            var creator = this.state.creadorRole;
            if (check) {
                var el = creator.indexOf(id);
                if (el > -1) {
                    creator.splice(el, 1);
                    this.setState({ creadorRole: creator });
                    this.removeRole(id, "Creador");
                }
            }
            else {
                creator.push(id);
                this.setState({ creadorRole: creator });
                this.assignRole(id, "Creador");
            }
        }
    };
    Administrador.prototype.toggle = function (tab) {
        if (this.state.activeTab !== tab)
            this.setState({ activeTab: tab });
    };
    Administrador.prototype.onChangeArea = function (event) {
        var cod = event.target.value;
        this.setState({ idArea: cod });
    };
    Administrador.prototype.renderSwitch = function (param) {
        switch (param) {
            case 'P':
                return 'Pendiente';
            case 'A':
                return 'Aprobado';
            case 'B':
                return 'Borrador';
            case 'R':
                return 'Rechazado';
            default:
                return '';
        }
    };
    Administrador.prototype.end = function () {
        espolAds_js_1.expiro();
        this.props.history.push('/general/principal');
    };
    Administrador.prototype.isForbiden = function () {
        if (espolAds_js_1.getCookie("username") === null && !espolAds_js_1.getCookie('isAdmin'))
            this.props.history.push('/general/principal');
    };
    Administrador.prototype.render = function () {
        var contents = (this.state.status == 0)
            ? React.createElement("div", null,
                React.createElement("h5", { className: "title" }, "Loading...."),
                React.createElement("div", { className: "loader" }))
            : (this.state.status != 200 && this.state.status != 201) ? this.end()
                : this.renderUsersTable(this.state.pageUsers, this.state.users);
        /*this.state.status == 401 ? this.props.history.push('/general/principal')*/
        /*<Row><Col md={12}><Card><CardHeader>401 Unauthorized</CardHeader><CardBody>Necesita un usuario tipo Administrador para acceder.</CardBody></Card></Col></Row>*/
        /*: this.state.status == 403 ? this.props.history.push('/general/principal')*/
        /*<Row><Col md={12}><Card><CardHeader>403 FORBIDDEN</CardHeader><CardBody>No pertenece al tipo de usuario Administrador.</CardBody></Card></Col></Row>*/
        /*: this.state.status == 404 ? this.props.history.push('/general/principal')*/
        /*<Row><Col md={12}><Card><CardHeader>404 NOT FOUND</CardHeader><CardBody>No existe.</CardBody></Card></Col></Row>*/
        return React.createElement("div", null,
            React.createElement("div", { id: "top" }),
            React.createElement(reactstrap_1.Card, null,
                React.createElement(reactstrap_1.CardHeader, null,
                    React.createElement("h5", { className: "title" }, "ADMINISTRADOR DE USUARIOS")),
                React.createElement(reactstrap_1.CardBody, null, contents)));
    };
    Administrador.prototype.handleSearch = function (event) {
        this.setState({ buscar: event.target.value });
        /*console.log(this.state.buscar);*/
    };
    Administrador.prototype.handleUsuarioName = function (event) {
        this.setState({ usuario: event.target.value });
        /*console.log(this.state.usuario);*/
    };
    Administrador.prototype.handleUserName = function (event) {
        this.setState({ UserName: event.target.value });
        /*console.log(this.state.UserName);*/
    };
    Administrador.prototype.handleNombreBusq = function (event) {
        this.setState({ nombreBusqueda: event.target.value });
        console.log(this.state.nombreBusqueda);
    };
    Administrador.prototype.handleApellidoBusq = function (event) {
        this.setState({ apellidoBusqueda: event.target.value });
        console.log(this.state.apellidoBusqueda);
    };
    Administrador.prototype.handleInmortales = function (event) {
        var secreto = "fuerza antes que debilidad";
        var a = true;
        if (event.target.value == secreto) {
            a = false;
        }
        this.setState({ palabrasinmortales: event.target.value, notpass: a });
        /*console.log(this.state.buscar);*/
    };
    Administrador.prototype.handleEmail = function (u) {
        console.log(correoMasivo + u);
        fetch(correoMasivo + u);
        this.props.history.push('/general/principal');
    };
    Administrador.prototype.consultarNombres = function (nombre, apellido) {
        var _this = this;
        this.setState({ notvalid: true });
        console.log(nombre + " " + apellido);
        var nomb = nombre.replace(" ", "$");
        var apel = apellido.replace(" ", "$");
        /*console.log(nomb + " " + apel);*/
        fetch(account + 'ConsultaGestor/' + nomb + "/" + apel, {
            method: 'GET',
            headers: { "Authorization": "Bearer " + espolAds_js_1.getCookie('token') },
        })
            .then(function (response) {
            _this.setState({ status: response.status });
            return response.json();
        })
            .then(function (dataP) {
            console.log(dataP);
            _this.setState({ respuestaUser: dataP, notvalid: dataP.code, idArea: dataP.areaPrincipalId, OtrasAreas: dataP.areasExtra });
        });
        /*this.props.history.push('/general/principal');*/
        //console.log(this.state.respuestaUser.userName);
        //console.log(this.state.respuestaUser.gestorId);
        //console.log(this.state.idArea);
        console.log(this.state.OtrasAreas);
    };
    Administrador.prototype.comboRole = function (event) {
        this.setState({ role: event.target.value });
        /*console.log(this.state.role);*/
    };
    // Returns the HTML table to the render() method.  
    Administrador.prototype.renderUsersTable = function (pageUsers, users) {
        var _this = this;
        var optChosed = this.state.OtrasAreas.length > 0 ?
            this.state.areas.filter(function (x) { return _this.state.OtrasAreas.includes(x.value); })
            : [];
        return (React.createElement(React.Fragment, null,
            " ",
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, { md: 12 },
                    React.createElement(reactstrap_1.Card, null,
                        React.createElement(reactstrap_1.CardBody, { className: "main-content" },
                            React.createElement("div", null,
                                React.createElement(reactstrap_3.Nav, { pills: true },
                                    React.createElement(reactstrap_3.NavItem, null,
                                        React.createElement(reactstrap_3.NavLink, { className: classnames_1.default({ active: this.state.activeTab === '1' }), onClick: function () { _this.toggle('1'); } }, "Usuarios")),
                                    React.createElement(reactstrap_3.NavItem, null,
                                        React.createElement(reactstrap_3.NavLink, { className: classnames_1.default({ active: this.state.activeTab === '2' }), onClick: function () { _this.toggle('2'); } }, "Crear Gestor")),
                                    React.createElement(reactstrap_3.NavItem, null,
                                        React.createElement(reactstrap_3.NavLink, { className: classnames_1.default({ active: this.state.activeTab === '6' }), onClick: function () { _this.toggle('6'); } }, "EmailMasivo"))),
                                React.createElement(reactstrap_3.TabContent, { activeTab: this.state.activeTab },
                                    React.createElement(reactstrap_3.TabPane, { tabId: "1" },
                                        React.createElement(reactstrap_1.Row, null,
                                            React.createElement("div", { className: "col-md-1" },
                                                React.createElement("form", { className: "form-80" },
                                                    React.createElement(reactstrap_2.InputGroup, { className: "" },
                                                        React.createElement(reactstrap_2.InputGroupAddon, null,
                                                            React.createElement(reactstrap_2.InputGroupText, { onClick: function (e) { return _this.cambiarTap(null); } },
                                                                React.createElement("i", { className: "fas fa-redo" })))))),
                                            React.createElement("div", { className: "col-md-8" },
                                                React.createElement(reactstrap_2.InputGroup, { className: "" },
                                                    React.createElement(reactstrap_2.Input, { placeholder: "Buscar...", onChange: this.handleSearch, onKeyPress: this.handleKeyPress, value: this.state.buscar }),
                                                    React.createElement(reactstrap_2.InputGroupAddon, { addonType: "append" },
                                                        React.createElement(reactstrap_2.InputGroupText, { onClick: function (e) { return _this.cambiarTap(_this.state.buscar); } },
                                                            React.createElement("i", { className: "now-ui-icons ui-1_zoom-bold" }))))),
                                            React.createElement("div", { className: "pagination col-md-3 c-right" },
                                                React.createElement("a", { onClick: function (pag) { return _this.cambiarPagina(pageUsers.firstPage); } }, "\u00AB"),
                                                React.createElement("a", { hidden: pageUsers.previousPage == null, onClick: function (pag) { return _this.cambiarPagina(pageUsers.previousPage); } }, pageUsers.previousPage != null ? pageUsers.pageNumber - 1 : "-"),
                                                React.createElement("a", { className: "active" }, pageUsers.pageNumber),
                                                React.createElement("a", { hidden: pageUsers.nextPage == null, onClick: function (pag) { return _this.cambiarPagina(pageUsers.nextPage); } }, pageUsers.nextPage != null ? pageUsers.pageNumber + 1 : "-"),
                                                React.createElement("a", { onClick: function (pag) { return _this.cambiarPagina(pageUsers.lastPage); } }, "\u00BB"))),
                                        React.createElement("table", { className: 'table col-md-12' },
                                            React.createElement("div", { className: "mb-4" }),
                                            React.createElement("thead", null,
                                                React.createElement("tr", null,
                                                    React.createElement("th", { className: "col-md-3" }, "User-Name"),
                                                    React.createElement("th", { className: "col-md-1" }),
                                                    React.createElement("th", { className: "col-md-2" }, "Creador"),
                                                    React.createElement("th", { className: "col-md-1" }),
                                                    React.createElement("th", { className: "col-md-2" }, "Revisor"),
                                                    React.createElement("th", { className: "col-md-1" }),
                                                    React.createElement("th", { className: "col-md-2" }, "Admin"))),
                                            React.createElement("tbody", null, pageUsers.data.map(function (user) {
                                                return React.createElement("tr", { key: user["id"] },
                                                    React.createElement("td", null, user["userName"].split("@")[0]),
                                                    React.createElement("td", null,
                                                        React.createElement("input", { id: user["id"] + "-Creador", checked: _this.state.creadorRole.includes(user["id"]), className: "form-control", type: "checkbox", onClick: function () { return _this.checkChange(user["id"], "Creador", _this.state.creadorRole.includes(user["id"])); }, value: "true" })),
                                                    React.createElement("td", null,
                                                        React.createElement("label", { id: user["id"] + "-CreadorL" }, _this.state.creadorRole.includes(user["id"]) ? "Asignado" : "Removido")),
                                                    React.createElement("td", null,
                                                        React.createElement("input", { id: user["id"] + "-Revisor", checked: _this.state.revisorRole.includes(user["id"]), className: "form-control", type: "checkbox", onClick: function () { return _this.checkChange(user["id"], "Revisor", _this.state.revisorRole.includes(user["id"])); }, value: "true" })),
                                                    React.createElement("td", null,
                                                        React.createElement("label", { id: user["id"] + "-RevisorL" }, _this.state.revisorRole.includes(user["id"]) ? "Asignado" : "Removido")),
                                                    React.createElement("td", null,
                                                        React.createElement("input", { id: user["id"] + "-Admin", checked: _this.state.adminRole.includes(user["id"]), className: "form-control", onClick: function () { return _this.checkChange(user["id"], "Administrador", _this.state.adminRole.includes(user["id"])); }, type: "checkbox", value: "true" })),
                                                    React.createElement("td", null,
                                                        React.createElement("label", { id: user["id"] + "-AdminL" }, _this.state.adminRole.includes(user["id"]) ? "Asignado" : "Removido")));
                                            }))))),
                                React.createElement(reactstrap_3.TabContent, { activeTab: this.state.activeTab },
                                    React.createElement(reactstrap_3.TabPane, { tabId: "2" },
                                        React.createElement(reactstrap_1.Card, null,
                                            React.createElement(reactstrap_1.CardHeader, null,
                                                React.createElement("h6", null, "Crear Gestor ")),
                                            React.createElement(reactstrap_1.CardBody, null,
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, "Nombres"),
                                                    React.createElement("div", { className: "col-md-4" },
                                                        React.createElement("input", { className: "form-control", type: "text", id: "txNombre", name: "txNombre", value: this.state.nombreBusqueda, onChange: this.handleNombreBusq })),
                                                    React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, "Apellidos"),
                                                    React.createElement("div", { className: "col-md-4" },
                                                        React.createElement("input", { className: "form-control", type: "text", id: "txApellido", name: "txApellido", value: this.state.apellidoBusqueda, onChange: this.handleApellidoBusq }))),
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("button", { className: "btn-info btn-round", onClick: function () { return _this.consultarNombres(_this.state.nombreBusqueda, _this.state.apellidoBusqueda); } }, "Consultar")),
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, "Nombre Completo *"),
                                                    React.createElement("div", { className: "col-md-10" },
                                                        React.createElement("input", { className: "form-control", readOnly: true, type: "text", id: "txNombreC", name: "txNombreC", defaultValue: this.state.respuestaUser.nombreCompleto, required: true }))),
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, " Usuario "),
                                                    React.createElement("div", { className: "col-md-10" },
                                                        React.createElement("input", { className: "form-control", readOnly: true, type: "text", id: "txUserName", name: "txUserName", defaultValue: this.state.respuestaUser.userName }))),
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, "Area Principal*"),
                                                    React.createElement("div", { className: "col-md-8" },
                                                        React.createElement("select", { className: "  control-label form-control", id: "idArea", name: "idArea", onChange: this.onChangeArea, value: this.state.idArea, required: true }, this.state.areas.map(function (area) {
                                                            return React.createElement("option", { key: area.idArea, selected: area.idArea == _this.state.idArea, value: area.idArea }, area.txNombreArea);
                                                        })))),
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, "Otras Areas"),
                                                    React.createElement("div", { className: "col-md-8" },
                                                        React.createElement(react_select_1.default, { closeMenuOnSelect: true, isMulti: true, onChange: this.onChangeMulti, name: "otrasAreas", options: this.listaMultiSelect(this.state.areas), defaultValue: optChosed }))),
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, "Mensaje"),
                                                    React.createElement("div", { className: "col-md-8" },
                                                        React.createElement("input", { className: "form-control", readOnly: true, type: "text", id: "txMensaje", name: "txMensaje", defaultValue: this.state.respuestaUser.mensaje }))))),
                                        React.createElement("button", { disabled: this.state.notvalid, className: this.state.notvalid ? "btn-dark btn-round" : "btn-info btn-round", onClick: function () { return _this.crearGestor(_this.state.respuestaUser.userName, _this.state.idArea); } }, "Crear"))),
                                React.createElement(reactstrap_3.TabContent, { activeTab: this.state.activeTab },
                                    React.createElement(reactstrap_3.TabPane, { tabId: "6" },
                                        React.createElement(reactstrap_1.Card, null,
                                            React.createElement(reactstrap_1.CardHeader, null,
                                                React.createElement("h6", null, "Enviar Email ")),
                                            React.createElement(reactstrap_1.CardBody, null,
                                                React.createElement("p", null, "Esta Opcion solo debe usarse en caso de no lanzarse el task para email masivo."),
                                                React.createElement("p", null, "Escribir usuario destino:"),
                                                React.createElement("input", { type: "input", value: this.state.usuario, onChange: this.handleUsuarioName, style: styles.password }),
                                                React.createElement("p", null, "Para desbloquera el bot\u00F3n se deben escribir las palabras inmortales."),
                                                React.createElement("input", { type: "password", value: this.state.palabrasinmortales, onChange: this.handleInmortales, placeholder: "Enter you password", style: styles.password }))),
                                        React.createElement("button", { disabled: this.state.notpass, className: this.state.notpass ? "btn-dark btn-round" : "btn-info btn-round", onClick: function () { return _this.handleEmail(_this.state.usuario); } }, "Enviar Email"))))))))));
    };
    return Administrador;
}(React.Component));
exports.Administrador = Administrador;
var PageUsers = /** @class */ (function () {
    function PageUsers() {
        this.pageNumber = 0;
        this.pageSize = 0;
        this.firstPage = "";
        this.lastPage = "";
        this.totalPages = 0;
        this.totalRecords = 0;
        this.nextPage = "";
        this.previousPage = "";
        this.succeeded = false;
        this.errors = "";
        this.message = "";
    }
    return PageUsers;
}());
exports.PageUsers = PageUsers;
var UsersRol = /** @class */ (function () {
    function UsersRol() {
        this.userId = "";
        this.userName = "";
        this.Creador = false;
        this.Revisor = false;
        this.Admin = false;
    }
    return UsersRol;
}());
exports.UsersRol = UsersRol;
var UserGestor = /** @class */ (function () {
    function UserGestor() {
        this.userId = "";
        this.userName = "";
        this.gestorId = 0;
        this.areaPrincipalId = 0;
        this.nombreCompleto = "";
        this.areasExtra = [];
    }
    return UserGestor;
}());
exports.UserGestor = UserGestor;
//# sourceMappingURL=Administrador.js.map